import { IProjectStatusMatrix } from '../../interfaces/iproject-status-matrix';
import { ProjectStatus } from '../project-status';

export class ProjectStatusMatrixBase {
  ProjectStatusMatrixId: number;
  CurrentProjectStatusId: number;
  NewProjectStatusId: number;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  AllowManual: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CurrentProjectStatus?: ProjectStatus;
  NewProjectStatus?: ProjectStatus;

  constructor(item?: IProjectStatusMatrix) {
    if (item) {

      this.ProjectStatusMatrixId = item.ProjectStatusMatrixId;
      this.CurrentProjectStatusId = item.CurrentProjectStatusId;
      this.NewProjectStatusId = item.NewProjectStatusId;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.AllowManual = item.AllowManual;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CurrentProjectStatus = new ProjectStatus(item.CurrentProjectStatus);
      this.NewProjectStatus = new ProjectStatus(item.NewProjectStatus);
    }
  }
}